import { FC } from "react";

interface Props {
  children: React.ReactNode;
}
const CardTitle: FC<Props> = ({ children }) => {
  return <h2>{children}</h2>;
};

export default CardTitle;
